// reports/Reportconfig.tsx
import type { DateTypeOption, ReportColumn, ShipmentMode } from "./Types";

export const MODE_LABEL: Record<ShipmentMode, string> = {
  air: "Air",
  ocean: "Ocean",
};

// Column order below is authoritative — it drives the table AND the exports.
const AIR_COLUMNS: ReportColumn[] = [
  { field: "sno", headerName: "Sno", kind: "sno", width: 60 },
  { field: "mode", headerName: "Mode", kind: "mode", width: 80 },
  { field: "trackingNumber", headerName: "Tracking Number", kind: "text", width: 130 },
  { field: "type", headerName: "Type", kind: "text", width: 80 },
  { field: "active", headerName: "Active", kind: "boolean", width: 100 },
  { field: "dateAdded", headerName: "Date Added", kind: "date", width: 130 },
  { field: "customer", headerName: "Customer", kind: "text", width: 180 },
  { field: "carrier", headerName: "Carrier", kind: "text", width: 160 },
  { field: "origin", headerName: "Origin", kind: "text", width: 120 },
  { field: "destination", headerName: "Destination", kind: "text", width: 120 },
  { field: "noOfPackets", headerName: "No. Pkts", kind: "number", width: 90 },
  { field: "weight", headerName: "Weight", kind: "number", width: 100 },
  { field: "currentStatus", headerName: "Current Status", kind: "text", width: 170 },
  { field: "gateIn", headerName: "Gate In", kind: "date", width: 130 },
  { field: "originDeparture", headerName: "Origin Departure", kind: "date", width: 150 },
  { field: "destinationArrival", headerName: "Destination Arrival", kind: "date", width: 160 },
  { field: "delivered", headerName: "Delivered", kind: "date", width: 130 },
  { field: "flags", headerName: "Flags", kind: "flags", width: 160 },
];

const OCEAN_COLUMNS: ReportColumn[] = [
  { field: "sno", headerName: "Sno", kind: "sno", width: 60 },
  { field: "mode", headerName: "Mode", kind: "mode", width: 80 },
  { field: "trackingNumber", headerName: "Tracking Number", kind: "text", width: 140 },
  { field: "type", headerName: "Type", kind: "text", width: 80 },
  { field: "active", headerName: "Active", kind: "boolean", width: 100 },
  { field: "dateAdded", headerName: "Date Added", kind: "date", width: 130 },
  { field: "customer", headerName: "Customer", kind: "text", width: 180 },
  { field: "carrier", headerName: "Carrier", kind: "text", width: 160 },
  { field: "origin", headerName: "Origin", kind: "text", width: 120 },
  { field: "destination", headerName: "Destination", kind: "text", width: 120 },
  { field: "noOfPackets", headerName: "No. Pkts", kind: "number", width: 90 },
  { field: "weight", headerName: "Weight", kind: "number", width: 100 },
  { field: "currentStatus", headerName: "Current Status", kind: "text", width: 170 },
  { field: "containerPickup", headerName: "Container Pickup", kind: "date", width: 150 },
  { field: "gateIn", headerName: "Gate In", kind: "date", width: 130 },
  { field: "loadedOnVessel", headerName: "Loaded on Vessel", kind: "date", width: 150 },
  { field: "originDeparture", headerName: "Origin Departure", kind: "date", width: 150 },
  { field: "destinationArrival", headerName: "Destination Arrival", kind: "date", width: 160 },
  { field: "delivered", headerName: "Delivered", kind: "date", width: 130 },
  { field: "containerReturn", headerName: "Container Return", kind: "date", width: 150 },
  { field: "flags", headerName: "Flags", kind: "flags", width: 160 },
];

export function getColumns(mode: ShipmentMode): ReportColumn[] {
  return mode === "air" ? AIR_COLUMNS : OCEAN_COLUMNS;
}

const AIR_DATE_TYPES: DateTypeOption[] = [
  { value: "dateAdded", label: "Date Added" },
  { value: "gateIn", label: "Gate In" },
  { value: "originDeparture", label: "Origin Departure" },
  { value: "destinationArrival", label: "Destination Arrival" },
  { value: "delivered", label: "Delivered" },
];

const OCEAN_DATE_TYPES: DateTypeOption[] = [
  { value: "dateAdded", label: "Date Added" },
  { value: "containerPickup", label: "Container Pickup" },
  { value: "gateIn", label: "Gate In" },
  { value: "loadedOnVessel", label: "Loaded on Vessel" },
  { value: "originDeparture", label: "Origin Departure" },
  { value: "destinationArrival", label: "Destination Arrival" },
  { value: "delivered", label: "Delivered" },
  { value: "containerReturn", label: "Container Return" },
];

export function getDateTypeOptions(mode: ShipmentMode): DateTypeOption[] {
  return mode === "air" ? AIR_DATE_TYPES : OCEAN_DATE_TYPES;
}